import React from "react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1678886700765-a77726e01810?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxzY2FuZGluYXZpYW4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3Nzg5NjU4NXww&ixlib=rb-4.1.0&q=85";

export default function Hero({ t }) {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero"
      className="relative pt-28 md:pt-32 pb-16 md:pb-24 bg-[#F8F9FA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        {/* Left text */}
        <div className="lg:col-span-6 pt-6 lg:pt-16">
          <div
            className="text-[12px] tracking-[0.28em] uppercase text-[#475569] mb-6"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            {t.hero.eyebrow}
          </div>
          <h1
            className="text-[44px] sm:text-[56px] lg:text-[72px] leading-[0.98] tracking-tight text-[#0A0F1C] font-bold"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {t.hero.title_a}
            <br />
            <span className="text-[#0F2C29]">{t.hero.title_b}</span>
            <br />
            <span
              className="italic font-normal"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {t.hero.title_c}
            </span>
          </h1>

          <p
            className="mt-8 text-[17px] leading-relaxed text-[#475569] max-w-xl"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            {t.hero.desc}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => go("contact")}
              className="bg-[#0F2C29] hover:bg-[#17423E] text-white text-[12px] font-bold tracking-[0.22em] uppercase px-8 py-4 transition-colors"
            >
              {t.hero.cta_primary}
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => go("services")}
              className="border border-[#0F2C29] text-[#0F2C29] hover:bg-[#0F2C29] hover:text-white text-[12px] font-bold tracking-[0.22em] uppercase px-8 py-4 transition-colors"
            >
              {t.hero.cta_secondary}
            </button>
          </div>

          {/* Stats */}
          <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg">
            {[
              [t.hero.stat_1, t.hero.stat_1_label],
              [t.hero.stat_2, t.hero.stat_2_label],
              [t.hero.stat_3, t.hero.stat_3_label],
            ].map(([val, lab], i) => (
              <div key={i} className="border-t border-[#0A0F1C]/15 pt-3">
                <div
                  className="text-[15px] font-semibold text-[#0A0F1C]"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {val}
                </div>
                <div
                  className="text-[11px] tracking-[0.18em] uppercase text-[#475569] mt-1"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                  {lab}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right image */}
        <div className="lg:col-span-6 relative">
          <div className="relative w-full h-[380px] sm:h-[480px] lg:h-[640px] overflow-hidden">
            <img
              src={HERO_IMG}
              alt="Scandinavian house facade"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-black/5" />
          </div>
          {/* corner stat */}
          <div className="absolute -bottom-6 -left-6 hidden md:block bg-[#0F2C29] text-white px-6 py-5 max-w-[260px]">
            <div
              className="text-[11px] tracking-[0.22em] uppercase opacity-80"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Akershus · Oslo
            </div>
            <div
              className="text-[20px] mt-2 leading-snug"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Personlig service<br />fra A til Å.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
